export default __webpack_public_path__ + "static/birthcontrol3-9e1ffaab76e2cc084ea7bdbae543f2b6.png";